import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux";
import {selectAnnotationStyleLabel, updateAnnotationStyleLabel } from "../app/annotations";

// label is the text displayed on the annotations
// every value contained in the data field of annotations can be displayed
const FeatureLabelHandler = ({annotationsFields}) => {
  // default string is set here to avoid modifying multiple places if value is changed
  const defaultLabelString = "None"
  const dispatch = useDispatch();
  const annotationStyleLabel = useSelector(selectAnnotationStyleLabel)
  // updated label in state
  useEffect(() => {
    dispatch(updateAnnotationStyleLabel(annotationStyleLabel))
  }, [annotationStyleLabel])

  // Handle input change
  const handleSelectChange = (event) => {
    dispatch(updateAnnotationStyleLabel(event.target.value))
  };

  return (
    <div className="filters">
      <div className="filter-box">
        <h5 key={"labels"} style={{margin: 5}}>Label</h5>
        <select
          name="Label"
          value={annotationStyleLabel}
          onChange={handleSelectChange}
        >
          {[{id: defaultLabelString, name: defaultLabelString, title: defaultLabelString}, ...annotationsFields.keys].map((af) => {
            return (
              <option key={af.name} value={af.name}>
                {af.title}
              </option>
            )
          })}
        </select>
      </div>
    </div>
  )
}

export default FeatureLabelHandler;